import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentTimezone from 'moment-timezone';

export default class FormattedTime extends Component {
  render() {
    const { format, tz, value } = this.props;
    let dateTime;

    if (typeof value === 'undefined') {
      dateTime = '';
    } else if (tz) {
      dateTime = momentTimezone(value).tz(tz).format(format);
    } else {
      dateTime = moment(value).format(format);
    }
    return (
      <span>
        {dateTime}
      </span>
    );
  }
}

FormattedTime.propTypes = {
  value: PropTypes.node.isRequired,
  format: PropTypes.string,
  tz: PropTypes.string,
};

FormattedTime.defaultProps = {
  format: 'YYYY.MM.DD'
};



// WEBPACK FOOTER //
// ./src/components/FormattedTime/index.js